module.exports = __webpack_public_path__ + "img/defb0842a61e46576450e5fe1ebb1469.gif";